
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#241F21","stroke-width":"2","stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M29.71 16.56h-7.59A9.83 9.83 0 0013.29 11v8.38c-4.24 2.64-5.39 7.9-6.46 13H1.5c0 6.7.48 11.17 7 11.47a10.73 10.73 0 005.78 4.92v9h6.5L24.1 53h20.64v4.77h6.51a36.24 36.24 0 007.25-21.56c0-10.31-6.39-19.65-16.71-19.65h-3.28"}}),_c('path',{attrs:{"d":"M14.28 33.27a2.948 2.948 0 014.113-2.88 2.95 2.95 0 011.777 2.88M26.81 21.47h14.74M34.18 18.03a7.86 7.86 0 100-15.72 7.86 7.86 0 000 15.72z"}})])])
          )
        }
      }
    